import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

/**
 * [T68P1-b] Confirmation dialog shown when user tries to close a dirty form.
 *
 * When `onSaveDraft` is provided a third "Save as Draft" button is shown,
 * allowing the user to persist their progress without committing the record.
 */
interface DiscardChangesDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  /** Optional handler for the "Save as Draft" action. */
  onSaveDraft?: () => void;
}

export function DiscardChangesDialog({ open, onConfirm, onCancel, onSaveDraft }: DiscardChangesDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Discard unsaved changes?</AlertDialogTitle>
          <AlertDialogDescription>
            You have unsaved changes that will be lost if you close this form. Would you like to
            keep editing, save your progress as a draft, or discard your changes?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel onClick={onCancel}>Keep Editing</AlertDialogCancel>
          {onSaveDraft && (
            <AlertDialogAction
              onClick={onSaveDraft}
              className="bg-amber-500 text-white hover:bg-amber-600"
            >
              Save as Draft
            </AlertDialogAction>
          )}
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Discard Changes
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default DiscardChangesDialog;
